import React,{useEffect,useState} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
function HistoryTab() {
  const {clinicId} = useParams()
  const [historyList,setHistoryList] = useState([])
  const [rowCount,setRowCount] = useState(10)
  const [paginationModel,setPaginationModel] = useState({
    page:0,
    pageSize:5,
 })

 const columns = [
    {field:"id",headerName:"ID",width:'80'},
    {field:"notes",headerName:"Notes",width:'500'},
    {field:"result",headerName:"Result",width:'100'},
    {field:"PMSType",headerName:"PMS Type",width:'100'},
    {field:"updatedAt", headerName:"Updated",width:'200'}
 ]

  useEffect(()=>{
    getHistory(clinicId,paginationModel.page,paginationModel.pageSize)
  },[paginationModel.page,paginationModel.pageSize])
 
  const getHistory = (clinicid,pageNo,pageSize)=>{
      clinicService.getHistory(clinicid,pageNo,pageSize)
      .then(res=>{
        setHistoryList(res.data.content)
        setRowCount(res.data.totalElements)
      })
      .catch(err=>{
        console.log(err)
      })
  }
  return (
    <>
       <h5 className="card-title" style={{ color: "#012970" }}>
              History
            </h5>
      <div style={{ width: '100%' }}>
      <DataGrid
        rows={historyList}
        columns={columns}
        rowCount={rowCount}
        pagination
        paginationModel={paginationModel}
        pageSizeOptions={[5, 10]}
        paginationMode='server'
        onPaginationModelChange={setPaginationModel}


       />
      </div>
    </>
  )
}

export default HistoryTab